import React, { useState, useRef, useEffect } from "react";
import { AppConfig } from "../../config";

type Option = {
  id: string;
  name: string;
  value: string;
};

interface CreatableSelectProps {
  options: Option[];
  value?: Option | null;
  optionName?: string;
  onChange: (option: any) => void;
  placeholder?: string;
}

export const CreatableSelect: React.FC<CreatableSelectProps> = ({
  options,
  value,
  optionName,
  onChange,
  placeholder = "Select or create...",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState<Option[]>(options);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setFilteredOptions(
      options.filter((opt) =>
        opt?.name?.toLowerCase()?.includes(inputValue.toLowerCase())
      )
    );
  }, [inputValue, options]);

  useEffect(() => {
    console.log("on value change :", value);
    if (value?.name) {
      setInputValue(value.name);
    }
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option: Option) => {
    let send_data = {
      from: "on_select",
      data: option,
    };
    onChange(send_data);
    setInputValue(option?.name);
    setIsOpen(false);
  };

  const handleCreate = () => {
    const newOption = {
      name: inputValue,
      value: inputValue?.toLowerCase().replace(/\s+/g, "-"),
    };
    let send_data = {
      from: "on_create",
      data: newOption,
    };
    onChange(send_data);
    setInputValue(newOption?.name);
    setIsOpen(false);
  };

  const showCreateOption =
    inputValue &&
    !options?.some(
      (opt) => opt?.name?.toLowerCase() === inputValue?.toLowerCase()
    );

  return (
    <div className="dropdown" ref={containerRef}>
      <div className="form-control radius-10 outside d-flex align-items-center custom-select">
        <input
          className="form-control border-0 px-0"
          //   value={inputValue || value?.name || ""}
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            setIsOpen(true); // keep it open when typing
          }}
          onFocus={() => setIsOpen(true)}
          //   placeholder={placeholder}
        />
        <span className="floating-custom-label text-black">{optionName}</span>
        <div className="ms-auto" onClick={() => setIsOpen((prev) => !prev)}>
          <img
            src={
              AppConfig.CDN_Media_url + "b1b871802f6048caa74336bf068322cb.svg"
            }
            className="w-10px"
            alt="toggle"
          />
        </div>
      </div>

      {isOpen && (
        <ul
          className="dropdown-menu show pt-2 mt-2"
          style={{ width: "100%", padding: "0" }}
        >
          {filteredOptions.map((opt) => (
            <li key={opt.value} className="">
              <button
                className="dropdown-item p-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect(opt)}
              >
                {opt.name}
              </button>
            </li>
          ))}
          {showCreateOption && (
            <li className="p-2 dropdown-item text-muted" onClick={handleCreate}>
              Create "{inputValue}"
            </li>
          )}
        </ul>
      )}
    </div>
  );
};
